import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-21667f4c"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "add-member-option"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "member-ul"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "keyword-input-box"
};
var _hoisted_7 = {
  key: 2,
  class: "desc-text"
};
var _hoisted_8 = {
  class: "keyword-input-box"
};
var _hoisted_9 = {
  key: 0,
  class: "no-text"
};
var _hoisted_10 = {
  key: 1,
  class: "group-tree-box"
};
var _hoisted_11 = ["onClick"];
var _hoisted_12 = {
  class: "label"
};
var _hoisted_13 = {
  class: "desc"
};
var _hoisted_14 = {
  class: "group-tree-box"
};
var _hoisted_15 = {
  class: "desc-text"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode(" 平台每日零点自动同步组织架构中最新名单。");

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("br", null, null, -1);
});

var _hoisted_18 = {
  key: 0
};
import { ElMessage } from 'element-plus';
import { useStore } from 'vuex';
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { uniq, debounce } from 'lodash';
import AuthService from '@/api/auth';
import CompanyService from '@/api/company';
import { defaultAvatar } from '@/config/constant';
import { useRoute } from 'vue-router';
import DtMessage from '@/components/DtMessage';
export default /*#__PURE__*/_defineComponent({
  props: {
    roleKeyValue: {
      // 角色组列表的key，value字段
      type: Array,
      default: function _default() {
        return ['id', 'name'];
      }
    },
    userKeyValue: {
      // 用户列表的key，value字段（仅外网才有）
      type: Array,
      default: function _default() {
        return ['loginName', 'name'];
      }
    },
    panelWidth: {
      // 下拉列表的宽度
      type: Number,
      default: 575
    },
    baseUrl: {
      // 接口前缀
      type: String,
      default: ''
    },
    roleList: Array,
    userList: Array,
    authOption: Object // 对象包含的key为roleSelected, userSelected, groupSelected，值都是数组类型

  },
  emits: ['updateAuthOption'],
  setup: function setup(__props, _ref) {
    var _window$AppConfig$aut;

    var emits = _ref.emit;
    var props = __props;
    var store = useStore(); // props

    var route = useRoute(); // 当前选中的tab

    var currentType = ref('user');
    var currentCorporationId = ref('');
    var userSelected = ref(props.authOption.userSelected);
    var roleSelected = ref(props.authOption.roleSelected); // 是否显示下拉列表

    var userVisible = ref(false); // 是否点击了下拉列表（用于是否避开鼠标失焦事件）

    var clickFlag = ref(false); // 搜索关键字和输入框回显数据

    var memberData = reactive({
      userKey: '',
      groupKey: '',
      userList: [],
      groupList: []
    }); // 下拉列表当前选中的索引（用于支持鼠标上下移动选中效果）

    var selectedIndex = ref(0);
    var treeProps = reactive({
      label: 'label',
      children: 'children',
      isLeaf: 'leaf'
    });
    var groupInputRef = ref(null);
    var groupTreeRef = ref(null);
    var addMemberData = reactive({
      addMemberList: []
    });
    watch(function () {
      return props.authOption;
    }, function () {
      userSelected.value = props.authOption.userSelected;
      roleSelected.value = props.authOption.roleSelected;
    }, {
      immediate: true,
      deep: true
    });
    watch(function () {
      return [roleSelected.value, userSelected.value];
    }, function () {
      var authOption = _objectSpread(_objectSpread({}, props.authOption), {}, {
        roleSelected: roleSelected.value,
        userSelected: userSelected.value
      });

      emits('updateAuthOption', authOption);
    }); // computed

    var hasRole = computed(function () {
      return Array.isArray(props.authOption.roleSelected);
    });
    var outerWebFlag = ref(window.AppConfig.outerWebFlag);
    var showGroupAuthorization = ref(window.AppConfig.showGroupAuthorization);
    var enableRoleSearch = ref((_window$AppConfig$aut = window.AppConfig.authority) === null || _window$AppConfig$aut === void 0 ? void 0 : _window$AppConfig$aut.enableRoleSearch); // mounted

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$CompanyService, corporationId;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (hasRole.value) {
                currentType.value = 'role';
              }

              _context.next = 3;
              return CompanyService.getEnteredLastCorporation();

            case 3:
              _yield$CompanyService = _context.sent;
              corporationId = _yield$CompanyService.data.result;

              if (corporationId === null) {
                ElMessage({
                  message: '无法获取当前企业信息',
                  type: 'error'
                });
              }

              currentCorporationId.value = corporationId;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))); // methods
    // 企业微信面板隐藏与展示

    var setUserVisible = function setUserVisible(flag) {
      userVisible.value = flag;
    }; // 点击面板中的选项，重新计算选中的数据


    var clickPanelItem = function clickPanelItem(node) {
      var type = currentType.value;
      var selectedKey = "".concat(type, "Selected");
      if (node) clickFlag.value = true;

      if (type === 'group') {
        groupInputRef.value.focus();
        var curIndex = props.authOption[selectedKey].findIndex(function (item) {
          return item.orgId === node.orgId;
        });

        if (curIndex === -1) {
          var authOption = props.authOption;
          authOption[selectedKey].push(node);
          emits('updateAuthOption', authOption);
        }
      } else {
        memberData["".concat(type, "Key")] = '';

        if (node) {
          // 排除点击空白处且不含;的情况
          var idList = props.authOption[selectedKey];
          var selectedNames = props.authOption.selectedNames;
          idList.push(node.user_id);
          selectedNames.push(node.user_name);
          var _authOption = props.authOption;
          _authOption[selectedKey] = uniq(idList);
          _authOption.selectedNames = uniq(selectedNames);
          emits('updateAuthOption', _authOption);
          setUserVisible(false);
        }
      }
    }; // 框失去焦点


    var handleBlur = function handleBlur() {
      var type = currentType.value;
      setUserVisible(false); // 延迟是为了让点击先执行

      setTimeout(function () {
        if (clickFlag.value) {
          clickFlag.value = false;
        } else if (type === 'group') {
          memberData["".concat(type, "Key")] = '';
        } else if (currentType.value === type) {
          // 排除点击tab失焦的情况
          clickPanelItem();
        }
      }, 300);
    }; // 鼠标经过面板中的各选项


    var handleMouseover = function handleMouseover() {
      selectedIndex.value = -1;
    }; // 鼠标按下


    var handleKeydown = function handleKeydown(e) {
      var key = "".concat(currentType.value, "List");

      if (e.keyCode === 40) {
        if (selectedIndex.value < memberData[key].length - 1) {
          selectedIndex.value = selectedIndex.value + 1;
        } else {
          selectedIndex.value = 0;
        }
      } else if (e.keyCode === 38) {
        if (selectedIndex.value > 0) {
          selectedIndex.value = selectedIndex.value - 1;
        } else {
          selectedIndex.value = memberData[key].length - 1;
        }
      } else if (e.keyCode === 13) {
        clickPanelItem(memberData[key][selectedIndex.value]);
      }
    }; // 删除已选择的节点


    var deleteSelectedNode = function deleteSelectedNode(userIndex) {
      var key = "".concat(currentType.value, "Selected");
      var deleteObj = props.authOption[key][userIndex];
      var authOption = props.authOption;
      authOption[key].splice(userIndex, 1);
      authOption.selectedNames.splice(userIndex, 1);
      emits('updateAuthOption', authOption); // 判断删除的节点为组织架构通过点击树节点而选中的节点（非搜索选中的节点）

      if (currentType.value === 'group' && deleteObj.level !== undefined) {
        groupTreeRef.value.setCheckedNodes(props.authOption[key]);
      }
    }; // 搜索企业用户


    var searchUser = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(keyword) {
        var _data$data;

        var values, lastValue, key, data, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                values = keyword.split(';');
                lastValue = values[values.length - 1].trim();
                key = "".concat(currentType.value, "List");
                _context2.next = 5;
                return AuthService.searchUserByKeyCommon(lastValue ? {
                  key: lastValue,
                  corporationId: currentCorporationId.value
                } : {
                  corporationId: currentCorporationId.value
                });

              case 5:
                data = _context2.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result;
                  selectedIndex.value = 0;
                  memberData[key] = result;
                  setUserVisible(result.length !== 0);
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function searchUser(_x) {
        return _ref3.apply(this, arguments);
      };
    }(); // 搜索组织架构


    var searchGroup = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(keyword) {
        var _data$data2;

        var key, data, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (keyword) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                key = "".concat(currentType.value, "List");
                _context3.next = 5;
                return AuthService.searchOrgByOrgNameLike({
                  orgName: keyword
                });

              case 5:
                data = _context3.sent;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  selectedIndex.value = 0;
                  result = data.data.result;
                  result.sort(function (cur, next) {
                    if (cur.orgName > next.orgName) return 1;
                    return -1;
                  });
                  result.forEach(function (item) {
                    item.label = item.orgName.replace(/.+\//, '');
                    item.desc = item.orgName.replace("/".concat(item.label), '');
                  });
                  memberData[key] = result;
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function searchGroup(_x2) {
        return _ref4.apply(this, arguments);
      };
    }(); // 默认加载组织架构的树节点


    var loadNode = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(node, resolve) {
        var _res$data;

        var data, level, params, res, _res$data$result, treeData;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = node.data, level = node.level;
                params = {};

                if (data) {
                  params = {
                    parentId: data.orgId
                  };
                }

                _context4.next = 5;
                return AuthService.getNextOrgInfoListByCorpId(params);

              case 5:
                res = _context4.sent;

                if (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 1) {
                  treeData = ((_res$data$result = res.data.result) === null || _res$data$result === void 0 ? void 0 : _res$data$result.subNodeList) || [];
                  treeData.forEach(function (item) {
                    Object.assign(item, {
                      level: level,
                      label: item.orgName.replace(/.+\//, '') // 取/的最后一段文本

                    });
                  });
                  resolve(treeData);
                }

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function loadNode(_x3, _x4) {
        return _ref5.apply(this, arguments);
      };
    }(); // 获取选中的组织架构节点


    var getCheckedNodes = function getCheckedNodes() {
      groupInputRef.value.focus();
      var checkNodes = groupTreeRef.value.getCheckedNodes();
      checkNodes.sort(function (cur, next) {
        if (cur.level === next.level) return 0;
        if (cur.level > next.level) return 1;
        return -1;
      }); // 去掉已选父类下的子类选项

      checkNodes.some(function (item, index) {
        checkNodes = checkNodes.filter(function (node) {
          return node.orgName === item.orgName || node.orgName.indexOf(item.orgName) !== 0;
        });
        if (index === checkNodes.length - 1) return true;
        return false;
      }); // 通过搜索关键字而选中的组织架构没有level属性

      var key = "".concat(currentType.value, "Selected");
      var ssNodes = props.authOption[key].filter(function (item) {
        return item.level === undefined;
      });
      var authOption = props.authOption;
      authOption[key] = checkNodes.concat(ssNodes);
      emits('updateAuthOption', authOption);
    }; // 搜索新增成员


    var searchMember = debounce( /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(value) {
        var _route$params$biz_url;

        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (value) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt("return", addMemberData.addMemberList = []);

              case 2:
                _context5.next = 4;
                return CompanyService.searchCompanyMember({
                  name: value,
                  biz_id: ((_route$params$biz_url = route.params.biz_url) === null || _route$params$biz_url === void 0 ? void 0 : _route$params$biz_url.toString()) || '',
                  corporation_id: ''
                });

              case 4:
                data = _context5.sent;

                if (data.data.code === 1) {
                  addMemberData.addMemberList = data.data.result;
                } else {
                  DtMessage({
                    type: 'error',
                    message: data.data.msg
                  });
                }

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }(), 200);
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_tab_pane = _resolveComponent("el-tab-pane");

      var _component_circle_close = _resolveComponent("circle-close");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_popover = _resolveComponent("el-popover");

      var _component_el_tree = _resolveComponent("el-tree");

      var _component_el_tabs = _resolveComponent("el-tabs");

      return _openBlock(), _createBlock(_component_el_tabs, {
        modelValue: currentType.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return currentType.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_unref(hasRole) ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 0,
            label: "角色组授权",
            name: "role"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_select, {
                style: {
                  "width": "100%"
                },
                modelValue: roleSelected.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return roleSelected.value = $event;
                }),
                filterable: "",
                multiple: "",
                placeholder: "请选择角色组"
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.roleList, function (item) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item[__props.roleKeyValue[0]],
                      label: item[__props.roleKeyValue[1]],
                      value: item[__props.roleKeyValue[0]]
                    }, null, 8, ["label", "value"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_tab_pane, {
            label: "用户授权",
            name: "user"
          }, {
            default: _withCtx(function () {
              return [enableRoleSearch.value ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                "show-search": "",
                multiple: "",
                filterable: "",
                remote: "",
                class: "member-select",
                placeholder: "请输入成员",
                style: {
                  "width": "100%"
                },
                name: "label",
                modelValue: userSelected.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return userSelected.value = $event;
                }),
                "popper-class": "add-member-options",
                "reserve-keyword": false,
                dropdownMatchSelectWidth: false,
                "default-active-first-option": false,
                "show-arrow": false,
                "filter-option": false,
                teleported: true,
                "remote-method": _unref(searchMember),
                onSearch: _unref(searchMember)
              }, {
                default: _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addMemberData).addMemberList, function (member) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: member.user_id,
                      value: member.user_id,
                      label: member.user_name
                    }, {
                      default: _withCtx(function () {
                        return [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
                          src: member.avatar || _unref(defaultAvatar),
                          alt: ""
                        }, null, 8, _hoisted_2), _createElementVNode("span", null, _toDisplayString(member.user_name) + "(" + _toDisplayString(member.email) + ")", 1)])];
                      }),
                      _: 2
                    }, 1032, ["value", "label"]);
                  }), 128))];
                }),
                _: 1
              }, 8, ["modelValue", "remote-method", "onSearch"])) : (_openBlock(), _createBlock(_component_el_popover, {
                key: 1,
                placement: "bottom-start",
                width: __props.panelWidth,
                visible: userVisible.value
              }, {
                reference: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.authOption.selectedNames, function (user, userIndex) {
                    return _openBlock(), _createElementBlock("div", {
                      class: "user-box",
                      key: user
                    }, [_createElementVNode("span", null, _toDisplayString(user), 1), _createVNode(_component_el_icon, {
                      class: "el-icon-circle-close",
                      onClick: function onClick($event) {
                        return deleteSelectedNode(userIndex);
                      }
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_circle_close)];
                      }),
                      _: 2
                    }, 1032, ["onClick"])]);
                  }), 128)), _createVNode(_component_el_input, {
                    modelValue: _unref(memberData).userKey,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return _unref(memberData).userKey = $event;
                    }),
                    size: "small",
                    placeholder: "请输入用户名搜索",
                    onKeydown: handleKeydown,
                    onInput: searchUser,
                    onBlur: handleBlur,
                    onFocus: _cache[3] || (_cache[3] = function ($event) {
                      return searchUser('');
                    })
                  }, null, 8, ["modelValue"])])];
                }),
                default: _withCtx(function () {
                  return [_createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberData).userList, function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      key: item['user_id'],
                      onClick: function onClick($event) {
                        return clickPanelItem(item);
                      },
                      onMouseover: handleMouseover,
                      class: _normalizeClass({
                        selected: selectedIndex.value === index
                      })
                    }, [_createElementVNode("img", {
                      src: "//dayu.oa.com/avatars/".concat(item['user_id'], "/avatar.jpg")
                    }, null, 8, _hoisted_5), _createElementVNode("span", null, _toDisplayString(item['user_name']), 1)], 42, _hoisted_4);
                  }), 128))])];
                }),
                _: 1
              }, 8, ["width", "visible"])), !outerWebFlag.value && _unref(hasRole) ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 若添加的人还没有空间权限，将被放入'访客'角色组7日清除。 ")) : _createCommentVNode("", true)];
            }),
            _: 1
          }), showGroupAuthorization.value ? (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: 1,
            label: "组织架构授权",
            name: "group"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_popover, {
                placement: "bottom-start",
                trigger: "click",
                width: __props.panelWidth
              }, {
                reference: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.authOption.groupSelected, function (group, groupIndex) {
                    return _openBlock(), _createElementBlock("div", {
                      class: "user-box",
                      key: group.orgId
                    }, [_createElementVNode("span", null, _toDisplayString(group.label), 1), _createVNode(_component_el_icon, {
                      class: "el-icon-circle-close",
                      onClick: function onClick($event) {
                        return deleteSelectedNode(groupIndex);
                      }
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_circle_close)];
                      }),
                      _: 2
                    }, 1032, ["onClick"])]);
                  }), 128)), _createVNode(_component_el_input, {
                    ref_key: "groupInputRef",
                    ref: groupInputRef,
                    modelValue: _unref(memberData).groupKey,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                      return _unref(memberData).groupKey = $event;
                    }),
                    size: "small",
                    placeholder: "输入组织架构关键字",
                    onKeydown: handleKeydown,
                    onInput: searchGroup,
                    onBlur: handleBlur
                  }, null, 8, ["modelValue"])])];
                }),
                default: _withCtx(function () {
                  return [_unref(memberData).groupKey && _unref(memberData).groupList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 暂无数据 ")) : _unref(memberData).groupKey ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberData).groupList, function (item, index) {
                    return _openBlock(), _createElementBlock("li", {
                      key: item.orgId,
                      onClick: function onClick($event) {
                        return clickPanelItem(item);
                      },
                      onMouseover: handleMouseover,
                      class: _normalizeClass({
                        selected: selectedIndex.value === index
                      })
                    }, [_createElementVNode("span", _hoisted_12, _toDisplayString(item.label), 1), _createElementVNode("span", _hoisted_13, _toDisplayString(item.desc), 1)], 42, _hoisted_11);
                  }), 128))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_tree, {
                    ref_key: "groupTreeRef",
                    ref: groupTreeRef,
                    "node-key": "orgId",
                    props: _unref(treeProps),
                    load: loadNode,
                    lazy: "",
                    "show-checkbox": "",
                    onCheck: getCheckedNodes
                  }, null, 8, ["props"])], 512), [[_vShow, !_unref(memberData).groupKey]])];
                }),
                _: 1
              }, 8, ["width"]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _unref(hasRole) ? (_openBlock(), _createElementBlock("span", _hoisted_18, "若添加的组织架构尚无空间权限，将被放入'访客'角色组7日清除。")) : _createCommentVNode("", true)])];
            }),
            _: 1
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});